import { render } from "./ShippingListItemView.vue?vue&type=template&id=d1252d06"
import script from "./ShippingListItemView.vue?vue&type=script&lang=js"
export * from "./ShippingListItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__